import { FC } from 'react';
import { TbArchive, TbEyeClosed } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

interface NestedResourceVisibilitySummaryProps {
    archivedCount: number;
    hiddenCount: number;
    resourceLabel: string;
}

const formatCount = (count: number, resourceLabel: string, state: 'Archived' | 'Hidden') =>
    `${count} ${resourceLabel}${count === 1 ? '' : 's'} ${state}`;

/** Shared archived/hidden state summary for nested workspace-resource tab bars. */
const NestedResourceVisibilitySummary: FC<NestedResourceVisibilitySummaryProps> = ({
    archivedCount,
    hiddenCount,
    resourceLabel,
}) => {
    const { token } = useAntDesignTheme();
    const label = [
        archivedCount > 0 ? formatCount(archivedCount, resourceLabel, 'Archived') : null,
        hiddenCount > 0 ? formatCount(hiddenCount, resourceLabel, 'Hidden') : null,
    ]
        .filter(Boolean)
        .join(' · ');

    if (archivedCount === 0 && hiddenCount === 0) {
        return null;
    }

    return (
        <small
            aria-label={label}
            style={{
                alignItems: 'center',
                color: token.colorTextTertiary,
                display: 'inline-flex',
                gap: '0.375rem',
                lineHeight: 1,
                verticalAlign: 'middle',
            }}
        >
            {archivedCount > 0 ? (
                <TbArchive size='0.875rem' style={{ display: 'block', flex: 'none' }} />
            ) : (
                <TbEyeClosed size='0.875rem' style={{ display: 'block', flex: 'none' }} />
            )}
            <span>{label}</span>
        </small>
    );
};

export default NestedResourceVisibilitySummary;
export type { NestedResourceVisibilitySummaryProps };
